import { useEffect } from 'react'

import firebase from 'gatsby-plugin-firebase'
import { parse } from 'query-string'

const Tracking = ({ location }) => {
  useEffect(() => {
    const newPath = location.pathname.substring(3)
    const locale = location.pathname.substring(0, 3)

    const { tc } = parse(location.search)

    firebase.analytics().logEvent('page_view', {
      page_location: location.href,
      page_path: newPath,
      locale,
      tracking_code: tc?.toString() || '',
    })

    try {
      const hubspot = (window._hsq = window._hsq || [])
      hubspot.push(['setPath', location.pathname + location.search])
      hubspot.push(['trackPageView'])
    } catch (e) {
      console.log(e)
    }
  })

  return null
}

export default Tracking
